// test220
(220 && 0);
